import ChevronRight from "@mui/icons-material/ChevronRight";
import OpenInNew from "@mui/icons-material/OpenInNew";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { CustomLink } from "core/components/CustomLink";
import { useBreakpoints } from "core/hooks/useBreakpoints";
import { NotificationDot } from "features/Notifications/NotificationDot";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { CorporateOnlyIcon } from "../CorporateOnlyIcon";
import { DMSWidgetListItemTemplate } from "./DMSWidgetListItemTemplate";
import type { SharedDMSWidgetListItemProps } from "./defs";
import { formatDmsDocumentLink } from "./formatDmsDocumentLink";

export type DMSWidgetLinkListItemProps = SharedDMSWidgetListItemProps & {
  documentLink: string;
};

export function DMSWidgetLinkListItem({
  id,
  title,
  dateText,
  dateLabel,
  documentLink,
  tags,
  parents,
  path,
  isCorporateOnly,
  onDocClick,
}: DMSWidgetLinkListItemProps) {
  const onLinkClick = useCallback(() => onDocClick?.(id), [onDocClick, id]);
  const { isMobile } = useBreakpoints();
  const { t } = useTranslation("DocumentManagementSystem", {
    keyPrefix: "Next:DocumentManagementSystem:DMSWidgetLinkListItem",
  });
  return (
    <DMSWidgetListItemTemplate
      id={id}
      parents={parents}
      dateLabel={dateLabel}
      dateText={dateText}
      tags={tags}
      AvatarSlot={
        <CustomLink href={formatDmsDocumentLink(path)}>
          <Avatar
            sx={{
              bgcolor: "divider",
              color: (theme) => theme.palette.text.secondary,
            }}
          >
            <OpenInNew color="inherit" />
          </Avatar>
        </CustomLink>
      }
      TitleSlot={
        <CustomLink href={formatDmsDocumentLink(path)}>
          <Typography variant="body1" sx={{ pb: 1 }} fontWeight="bold">
            {title}
            {isCorporateOnly && <CorporateOnlyIcon />}
            <NotificationDot mode="self" id={id} />
          </Typography>
        </CustomLink>
      }
      ButtonSlot={
        <Button
          size="small"
          target="_blank"
          onClick={onLinkClick}
          href={documentLink}
          LinkComponent={CustomLink}
          endIcon={<ChevronRight />}
        >
          {!isMobile && t("visit")}
        </Button>
      }
    />
  );
}
